import r from"./_isPrototype.js";import t from"./_nativeKeys.js";var o=r,e=t,a=Object.prototype.hasOwnProperty;var n=function(r){if(!o(r))return e(r);var t=[];for(var n in Object(r))a.call(r,n)&&"constructor"!=n&&t.push(n);return t};export{n as default};
//# sourceMappingURL=_baseKeys.js.map
